import httpService from './httpService';

const getPaged = (paggingSettings) => httpService.post('/api/language/getPaged', paggingSettings);

const getAll = () => httpService.get('/api/language/getAll');

export default {
  getPaged, getAll
};
